(function () {
  'use strict';

  // ▶ URL de ton serveur de tracking (ngrok en dev, domaine fixe en prod)
  var COLLECTOR_URL = 'https://tracker.lucid-store.com/collect';

  // ─────────────────────────────────────────────────────────────────────────
  // Helpers
  // ─────────────────────────────────────────────────────────────────────────

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function setCookie(name, value, days) {
    var exp = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value)
      + '; expires=' + exp + '; path=/; SameSite=Lax';
  }

  function getParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  function uuid() {
    return 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'.replace(/x/g, function () {
      return ((Math.random() * 16) | 0).toString(16);
    });
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Visitor ID — persisté 180 jours
  // ─────────────────────────────────────────────────────────────────────────

  var vid = getCookie('_trk_vid') || uuid();
  setCookie('_trk_vid', vid, 180);

  // ─────────────────────────────────────────────────────────────────────────
  // fbc — construit depuis fbclid dans l'URL, persisté 90 jours
  // ─────────────────────────────────────────────────────────────────────────

  // ── Meta ──────────────────────────────────────────────────────────────────
  var fbclid = getParam('fbclid');
  var fbc    = null;

  if (fbclid) {
    fbc = 'fb.1.' + Date.now() + '.' + fbclid;
    setCookie('_trk_fbc', fbc, 90);
  } else {
    fbc = getCookie('_trk_fbc');  // uniquement notre cookie — jamais le _fbc natif Meta
  }

  var fbp = getCookie('_fbp');

  // ── TikTok ────────────────────────────────────────────────────────────────
  // ttclid : TikTok Click ID, présent dans l'URL quand on clique une pub TikTok
  var ttclid = getParam('ttclid');
  if (ttclid) {
    setCookie('_trk_ttclid', ttclid, 7);  // expire 7 jours (fenêtre d'attribution TikTok)
  } else {
    ttclid = getCookie('_trk_ttclid');
  }

  // ── Snapchat ──────────────────────────────────────────────────────────────
  // sccid / ScCid : Snapchat Click ID
  var sccid = getParam('sccid') || getParam('ScCid');
  if (sccid) {
    setCookie('_trk_sccid', sccid, 28);  // expire 28 jours (fenêtre Snapchat)
  } else {
    sccid = getCookie('_trk_sccid');
  }

  // ─────────────────────────────────────────────────────────────────────────
  // UTM params — persistés 30 jours pour survivre à la navigation
  // ─────────────────────────────────────────────────────────────────────────

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var utms = {};

  UTM_KEYS.forEach(function (k) {
    var v = getParam(k) || getCookie('_trk_' + k);
    if (v) {
      utms[k] = v;
      setCookie('_trk_' + k, v, 30);
    }
  });

  // ─────────────────────────────────────────────────────────────────────────
  // Envoi d'un événement au serveur de tracking
  // ─────────────────────────────────────────────────────────────────────────

  function send(eventName, extra) {
    var payload = Object.assign(
      {
        vid:    vid,
        event:  eventName,
        url:    window.location.href,
        fbc:    fbc    || undefined,
        fbp:    fbp    || undefined,
        ttclid: ttclid || undefined,
        sccid:  sccid  || undefined,
      },
      utms,
      extra || {}
    );

    // XHR — supporte les headers custom (requis par ngrok)
    var xhr = new XMLHttpRequest();
    xhr.open('POST', COLLECTOR_URL, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('ngrok-skip-browser-warning', 'true');
    xhr.send(JSON.stringify(payload));
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Événements automatiques
  // ─────────────────────────────────────────────────────────────────────────

  // PageView — sur chaque page
  send('PageView');

  // ViewContent — sur les pages produit
  if (window.__st && window.__st.pageType === 'product') {
    send('ViewContent', {
      value:    window.__st.product ? window.__st.product.price / 100 : undefined,
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
    });
  }

  // AddToCart — clic sur les boutons d'ajout au panier
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-add-to-cart], .add-to-cart, #AddToCart, [name="add"]')) {
      send('AddToCart');
    }
  });

  // InitiateCheckout — clic sur les boutons de checkout
  document.addEventListener('click', function (e) {
    if (e.target.closest('[name="checkout"], #checkout, .cart__checkout, [href*="/checkout"]')) {
      send('InitiateCheckout');
    }
  });

  // ─────────────────────────────────────────────────────────────────────────
  // Jointure avec la commande Shopify
  // Écrit le vid dans les attributs du panier → stocké dans note_attributes
  // ─────────────────────────────────────────────────────────────────────────

  if (window.Shopify) {
    // On écrit TOUS les signaux pub dans la commande (note_attributes) pour qu'ils
    // voyagent avec elle, même si la jointure de session via vid échoue
    // (navigateur in-app TikTok/Snapchat qui perd les cookies au checkout).
    fetch('/cart/update.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ attributes: {
        vid:        vid,
        utm_source: utms.utm_source || '',
        ttclid:     ttclid || '',   // click ID TikTok
        sccid:      sccid  || '',   // click ID Snapchat
        fbc:        fbc    || '',   // click ID Meta
      } }),
    }).catch(function () {});
  }

})();
